import {
  DishCategoryOptionsTranslation,
  dishCategoryOptionsTranslation,
  DishUnitOptionsTranslation,
  dishUnitTypesOptionsTranslation,
} from '@/assets/locales/utils/dictionaries/dictionaries.translation.pl';
import { OfferElementDetailsDishPackageDialogFormModel } from '@/views/offerElements/details/components/dishPackage/components/dialog/model/OfferElementDetailsDishPackageDialogForm.model';

type DishGroupType = Record<keyof OfferElementDetailsDishPackageDialogFormModel, string> & {
  dishCategoryOptions: DishCategoryOptionsTranslation;
  unitOptions: DishUnitOptionsTranslation;
};
const dishGroup: DishGroupType = {
  department: 'Dział',
  dishCategory: 'Kategoria',
  dishCategoryOptions: dishCategoryOptionsTranslation,
  quantity: 'Ilość',
  type: 'Rodzaj dania',
  unit: 'Jednostka miary',
  unitOptions: dishUnitTypesOptionsTranslation,
};

export type OfferElementsDetailsDishPackageTranslation = {
  buttons: {
    addGroup: string;
  };
  dialog: {
    form: DishGroupType & {
      button: {
        cancel: string;
        submit: string;
      };
    };
    title: string;
  };
  group: DishGroupType & {
    button: {
      manageDishes: string;
    };
    dialog: {
      delete: {
        button: {
          cancel: string;
          delete: string;
        };
        content: string;
        title: string;
      };
      dishes: {
        button: {
          cancel: string;
          submit: string;
        };
        form: {
          fullTextSearchInput: string;
          seasonalityFrom: string;
          seasonalityTo: string;
          tags: string;
        };
      };
    };
    table: {
      head: {
        dietaryPreferences: string;
        name: string;
        seasonality: string;
      };
      title: string;
    };
  };
};

export const offerElementsDetailsDishPackageTranslation: OfferElementsDetailsDishPackageTranslation =
  {
    buttons: {
      addGroup: 'Dodaj grupę',
    },
    dialog: {
      form: {
        button: {
          cancel: 'Anuluj',
          submit: 'Zapisz',
        },
        ...dishGroup,
      },
      title: 'Dodaj pakiet',
    },
    group: {
      ...dishGroup,
      button: {
        manageDishes: 'Zarządzaj daniami',
      },
      dialog: {
        delete: {
          button: {
            cancel: 'Anuluj',
            delete: 'Usuń',
          },
          content: 'Czy na pewno chcesz usunąć grupę?',
          title: 'Usuń grupę',
        },
        dishes: {
          button: {
            cancel: 'Anuluj',
            submit: 'Zapisz',
          },
          form: {
            fullTextSearchInput: 'Wyszukaj...',
            seasonalityFrom: 'Od',
            seasonalityTo: 'Do',
            tags: 'Tagi',
          },
        },
      },
      table: {
        head: {
          dietaryPreferences: 'Preferencje żywieniowe',
          name: 'Nazwa',
          seasonality: 'Sezonowość',
        },
        title: 'Lista dań',
      },
    },
  };
